// extracted by mini-css-extract-plugin
module.exports = {"root":"AllSelection_root__sJd7O","action":"AllSelection_action__3Y-GG"};